import { render, staticRenderFns } from "./Qa.vue?vue&type=template&id=4dfec603&scoped=true&"
import script from "./Qa.vue?vue&type=script&lang=js&"
export * from "./Qa.vue?vue&type=script&lang=js&"
import style0 from "./Qa.vue?vue&type=style&index=0&id=4dfec603&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfec603",
  null
  
)

export default component.exports